<template>
  <div class="search-bar">
    <div class="search" :style="{
      border: '1px solid ' + (dataStyle && dataStyle.search_main_color ? dataStyle.search_main_color : '#A819EB'),
      boxShadow: '0px 10px 11px ' + (dataStyle && dataStyle.search_sub_color ? dataStyle.search_sub_color + '1F' : '#0E0EB11F'),

    }">
      <a-input :value="value" class="input" :placeholder="dataStyle && dataStyle.search_font ? dataStyle.search_font : '请输入商品关键词/链接/标题'" :style="{
        color: dataStyle && dataStyle.search_font_color ? dataStyle.search_font_color : '#7F7F7F80'
      }" @pressEnter="onConfirm" @input="$emit('onChange', $event.target.value)"/>
<!--      <a-icon type="search" class="icon"/>-->
      <img v-if="dataStyle && dataStyle.search_icon" class="icon" :src="dataStyle.search_icon" @click="onConfirm"/>
      <a-icon v-else type="search" class="icon" @click="onConfirm"/>
    </div>
    <div v-if="dataStyle && dataStyle.keyword_list" class="hots">
      <a v-for="(hot, idx) in dataStyle.keyword_list" :key="'hot' + idx" class="hot" :style="{
        color: hot.color
      }" @click="handleHot(hot)">
        {{hot.name}}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "zy-search-bar",
  model: {
    prop: 'value',
    event: 'onChange'
  },
  props: {
    mod: Object,
    value: String,
  },
  computed: {
    dataStyle() {
      return this.mod && this.mod.data ? JSON.parse(this.mod.data) : undefined
    }
  },
  data() {
    return {
      hots: ['短裙', '打底裤', '潮流', '睡衣', '休闲零食', '纯棉', '洗护', '美食', '运动']
    }
  },
  methods: {
    onConfirm() {
      this.$emit('onConfirm')
    },
    handleHot(hot) {
      console.log(hot)
      this.$router.push({
        path: '/search',
        query: {
          keyword: hot.name
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.search-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  .search {
    width: 80%;
    max-width: 624px;
    display: flex;
    align-items: center;
    height: 50px;
    border-radius: 40px;
    border: 1px solid #A819EB;
    background-color: white;
    padding-left: 20px;
    padding-right: 20px;
    box-shadow: 0px 10px 11px #0E0EB11F;

    .input {
      flex-grow: 1;
      margin-right: 10px;
      height: 100%;
      border: none ;
      outline: none;
      box-shadow: none;
      font-size: 14px;
    }
    .icon {
      flex-shrink: 0;
      font-size: 24px;
      color: #8F1AFF;
      cursor: pointer;
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }
  .hots {
    width: 80%;
    max-width: 624px;
    display: flex;
    margin-top: 10px;
    overflow-x: hidden;
    .hot {
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      padding: 4px 14px;
      flex-shrink: 0;
    }
  }
}
</style>
